(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /** Deterministic shuffle: same seed → same order (stable per product); different products → different order. */
  function shuffleInPlaceSeeded(arr, seedInput) {
    let seed = Number(seedInput);
    if (!Number.isFinite(seed)) seed = 1;
    seed = Math.floor(Math.abs(seed)) % 2147483646 || 1;
    function random01() {
      seed = (seed * 16807) % 2147483647;
      return (seed - 1) / 2147483646;
    }
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(random01() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  function buildBenSlide(r) {
    const card = document.createElement('div');
    card.className = 'product-reviews-ben__card';
    const quote = document.createElement('div');
    quote.className = 'product-reviews-ben__quote rte';
    quote.textContent = r.body || '';
    const by = document.createElement('p');
    by.className = 'product-reviews-ben__byline';
    const em = document.createElement('em');
    em.className = 'product-reviews-ben__name';
    em.textContent = r.name || '';
    const stars = document.createElement('span');
    stars.className = 'product-reviews-ben__stars';
    stars.setAttribute('aria-hidden', 'true');
    const n = Math.max(1, Math.min(5, parseInt(String(r.stars), 10) || 5));
    stars.textContent = '★'.repeat(n) + '☆'.repeat(5 - n);
    by.appendChild(em);
    by.appendChild(document.createTextNode(' '));
    by.appendChild(stars);
    card.appendChild(quote);
    card.appendChild(by);
    return card;
  }

  function fillFakeReviewSlides(root) {
    const pool = window.__productReviewsFakePool;
    if (!pool || !pool.length) return;
    const track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    const raw = parseInt(root.getAttribute('data-fake-pick-count') || '12', 10);
    const count = Number.isFinite(raw) ? Math.max(4, Math.min(24, raw)) : 12;
    const seedRaw = root.getAttribute('data-fake-seed');
    const seed = seedRaw != null && seedRaw !== '' ? seedRaw : '1';
    const copy = pool.slice();
    shuffleInPlaceSeeded(copy, seed);
    const picks = copy.slice(0, Math.min(count, copy.length));
    track.replaceChildren();
    picks.forEach((r) => track.appendChild(buildBenSlide(r)));
  }

  function getSlides(track) {
    return Array.from(track.children).filter((el) => el.nodeType === 1);
  }

  function scrollSlideIntoView(track, slide, behavior) {
    const be = reducedMotion ? 'auto' : behavior;
    const left = slide.offsetLeft - (track.clientLeft || 0);
    track.scrollTo({ left: Math.max(0, left), behavior: be });
  }

  function syncActiveIndex(track, slides) {
    if (!slides.length) return 0;
    const tLeft = track.getBoundingClientRect().left;
    let best = 0;
    let bestDist = Infinity;
    slides.forEach((slide, i) => {
      const dist = Math.abs(slide.getBoundingClientRect().left - tLeft);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    });
    return best;
  }

  function initCarousel(root) {
    if (root.dataset.carouselInitialized === 'true') return;
    if (root.hasAttribute('data-reviews-fake-shuffle')) {
      fillFakeReviewSlides(root);
    }
    const track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    root.dataset.carouselInitialized = 'true';

    const prevBtn = root.querySelector('[data-carousel-prev]');
    const nextBtn = root.querySelector('[data-carousel-next]');
    const dotsRoot = root.querySelector('[data-carousel-dots]');
    const noDots = root.hasAttribute('data-no-dots');
    const rawSec = parseInt(root.dataset.autoplaySeconds || '0', 10);
    const autoplayMs = Number.isFinite(rawSec) && rawSec > 0 ? rawSec * 1000 : 0;

    const details = root.closest('details');
    let index = 0;
    let autoplayTimer = null;
    let scrollEndTimer = null;

    function slides() {
      return getSlides(track);
    }

    function updateDots() {
      if (!dotsRoot || noDots) return;
      dotsRoot.querySelectorAll('.product-reviews-carousel__dot').forEach((btn, i) => {
        const on = i === index;
        btn.classList.toggle('is-active', on);
        if (on) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });
    }

    function goTo(i) {
      const s = slides();
      if (!s.length) return;
      const len = s.length;
      index = ((i % len) + len) % len;
      scrollSlideIntoView(track, s[index], 'smooth');
      updateDots();
    }

    function next() {
      goTo(index + 1);
    }

    function prev() {
      goTo(index - 1);
    }

    function buildDots() {
      if (!dotsRoot || noDots) return;
      const s = slides();
      dotsRoot.innerHTML = '';
      if (s.length <= 1) {
        dotsRoot.hidden = true;
        return;
      }
      dotsRoot.hidden = false;
      s.forEach((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-reviews-carousel__dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        if (i === 0) btn.setAttribute('aria-current', 'true');
        btn.addEventListener('click', () => goTo(i));
        dotsRoot.appendChild(btn);
      });
    }

    function onScroll() {
      clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(() => {
        index = syncActiveIndex(track, slides());
        updateDots();
      }, 60);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayMs || reducedMotion) return;
      if (details && !details.open) return;
      autoplayTimer = window.setInterval(next, autoplayMs);
    }

    function bind() {
      buildDots();
      const s0 = slides();
      index = syncActiveIndex(track, s0);
      updateDots();

      track.addEventListener('scroll', onScroll, { passive: true });

      prevBtn?.addEventListener('click', () => {
        prev();
        stopAutoplay();
        startAutoplay();
      });
      nextBtn?.addEventListener('click', () => {
        next();
        stopAutoplay();
        startAutoplay();
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);

      if (details) {
        details.addEventListener('toggle', () => {
          if (details.open) {
            window.requestAnimationFrame(() => {
              buildDots();
              index = 0;
              goTo(0);
              startAutoplay();
            });
          } else {
            stopAutoplay();
          }
        });
      }

      if (!details || details.open) {
        startAutoplay();
      }
    }

    window.requestAnimationFrame(bind);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-reviews-carousel]').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
